import React, { useEffect } from 'react'

import { Theme, Typography, makeStyles, useTheme } from '@material-ui/core'

import { Container } from '../../../../../components/Container'
import {
    AGENT_DRAWER_WIDTH,
    WALKTHROUGH_PANEL_HEIGHT,
} from '../../../../constants'
import { ProjectPlan } from './ProjectPlan/ProjectPlan'
import { OnboardTraining } from './OnboardTraining/OnboardTraining'
import { TrainingVideoController } from '../../../../../hooks/useTrainingVideo'
import { ProjectPlanController } from '../../../../../hooks/useProjectPlan'
import { typographyStyle } from '../../../../../theme/typographyStyle'

const useStyles = makeStyles((theme: Theme) => ({
    listItem: {
        alignItems: 'center',
        marginLeft: theme.spacing(1.5),
        marginTop: 0,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    checklist: {
        width: '100%',
        overflowY: 'scroll',
        maxHeight: WALKTHROUGH_PANEL_HEIGHT - 70,
    },
    menuItem: {
        height: 36,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '& span': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    },
    accordionSummary: {
        minHeight: '32px !important',
        height: '32px',
        '& .MuiAccordionSummary-content': {
            margin: '0 !important',
        },
        padding: '0 12px',
    },
}))

interface Props {
    trainingVideoController: TrainingVideoController
    projectPlanController: ProjectPlanController
    setSelectedChannel: (channel: LoriChannel) => void
}

export const WalkThroughChannelContent = ({
    trainingVideoController,
    projectPlanController,
    setSelectedChannel,
}: Props) => {
    const theme = useTheme()

    const classes = useStyles(theme)

    useEffect(() => {
        trainingVideoController.getOrCreateInitialUserTrainingProgress()
        trainingVideoController.getInitialTrainingVideos()
        projectPlanController.getProjectPlanList()
    }, [])

    return (
        <Container
            style={{
                flexDirection: 'column',
                width: AGENT_DRAWER_WIDTH,
                height: '100%',
            }}
        >
            {/* Header */}
            <Container
                style={{
                    padding: theme.spacing(1),
                    borderBottom: `2px solid ${theme.palette.divider}`,
                }}
            >
                <Typography
                    style={{
                        ...typographyStyle(theme.typography.h6),
                        fontWeight: 700,
                    }}
                >
                    Walk Throughs
                </Typography>
            </Container>
            {/* walkthrouhgs */}
            <Container
                style={{
                    flexDirection: 'column',
                }}
            >
                {/* onboard training */}
                <Container
                    style={{
                        borderBottom: `2px solid ${theme.palette.divider}`,
                        flexDirection: 'column',
                    }}
                >
                    {/* header */}
                    <Container
                        style={{
                            padding: theme.spacing(1),
                        }}
                    >
                        <Typography
                            style={{
                                ...typographyStyle(theme.typography.subtitle1),
                            }}
                        >
                            Onboard Training
                        </Typography>
                    </Container>
                    <OnboardTraining
                        trainingVideoController={trainingVideoController}
                        theme={theme}
                        setSelectedChannel={setSelectedChannel}
                    />
                </Container>

                {/* project plan */}
                <Container
                    style={{
                        borderBottom: `2px solid ${theme.palette.divider}`,
                        flexDirection: 'column',
                    }}
                >
                    {/* header */}
                    <Container
                        style={{
                            padding: theme.spacing(1),
                        }}
                    >
                        <Typography
                            style={{
                                ...typographyStyle(theme.typography.subtitle1),
                            }}
                        >
                            Project Plan
                            {projectPlanController.projectPlan && ` - `}
                            {projectPlanController.projectPlan && (
                                <span style={{ fontWeight: 'bold' }}>
                                    {
                                        projectPlanController.projectPlan
                                            .project.name
                                    }
                                </span>
                            )}
                        </Typography>
                    </Container>
                    {projectPlanController.projectPlan ? (
                        <ProjectPlan
                            projectPlanController={projectPlanController}
                            setSelectedChannel={setSelectedChannel}
                        />
                    ) : (
                        <Container
                            style={{
                                marginLeft: theme.spacing(2),
                                marginTop: theme.spacing(2),
                            }}
                        >
                            <Typography
                                style={{
                                    ...typographyStyle(
                                        theme.typography.subtitle2,
                                    ),
                                }}
                            >
                                You do not have a project plan yet. Ask Lori to
                                create one for you.
                            </Typography>
                        </Container>
                    )}
                </Container>
            </Container>
        </Container>
    )
}
